export default "__VITE_ASSET__772529b0__"